/**
 * ServerSettingsIcon — The server with a cog between its units: the Servers entry of the settings
 * half. Hugeicons server-cog (MIT).
 */

import svg from './svg/server-settings.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const ServerSettingsIcon = makeSvgIcon('server-settings', svg);
